import styled from 'styled-components';
import { Link } from 'react-router-dom';
import colors from '@theme/colors';

export const Subheader = styled.div`
  display: flex;
  background-color: #f9f9f9;
`;

export const ActiveTab = styled.div`
  color: ${colors.PRIMARY};
  font-size: 20px;
  font-weight: 700;
  padding: 20px 0 16px 0;
  width: 50%;
  text-align: center;
  border-bottom: 4px solid ${colors.PRIMARY};
`;

export const Tab = styled(Link)`
  color: #afafaf;
  font-size: 20px;
  font-weight: 700;
  padding: 20px 0;
  width: 50%;
  text-align: center;
  border-bottom: 1px solid ${colors.GREY};
  text-decoration: none;
`;



// WEBPACK FOOTER //
// ./components/layout/Subheader.js